import { Box, Collapse, Grid, IconButton, makeStyles, Tooltip } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { GoogleMap } from "components/Maps";
import { PAPS_OBS_PLACE_ID } from "config/constants";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { AddRequestInput } from "generated/graphql";
import { LocationIcon } from "icons";
import React from "react";

export const useRowStyles = makeStyles({
  root: {
    background: "#e2f4fb",
    height: "44px",
    borderRadius: "11px",
    padding: "10px",
    margin: "22px 0 0 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  },
  collapse: {
    background: "#399ebf",
    borderRadius: "8px",
    color: "#fff !important",
    height: "24px",
    width: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& .MuiIconButton-label": {
      color: "#fff",
    },
  },
  address: {
    fontSize: "14px",
    color: "#399ebf",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
  },
  map: {
    marginTop: "-23px",
  },
});

interface CollipsableAddressProps {
  requestQuote: AddRequestInput;
}

const CollipsableAddress = ({ requestQuote }: CollipsableAddressProps) => {
  const classes = useRowStyles();
  const [open, setOpen] = React.useState(false);

  const [coords, setCoords] = React.useState(null);
  const { step, setStep } = React.useContext(NewRequestQuoteContext);

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setCoords({ lat: position.coords.latitude, long: position.coords.longitude });
    });
  }, [requestQuote?.address]);

  return (
    <>
      {requestQuote?.address && (
        <>
          <Grid className={classes.root}>
            <Tooltip title={requestQuote?.address?.address}>
              <Box className={classes.address}>
                <LocationIcon />{" "}
                {requestQuote?.address?.address?.length > 47
                  ? `${requestQuote?.address?.address?.slice(0, 47)}...`
                  : requestQuote?.address?.address}
              </Box>
            </Tooltip>
            <Box className={classes.collapse}>
              <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </Box>
          </Grid>
          <Grid>
            <Box>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box className={classes.map}>
                  <GoogleMap
                    options={{
                      center: { lat: coords?.lat, lng: coords?.long },
                      zoom: 14,
                      disableDefaultUI: false,
                    }}
                    destination={requestQuote?.address?.place_id || PAPS_OBS_PLACE_ID}
                    orgin={requestQuote?.address?.place_id || PAPS_OBS_PLACE_ID}
                    height={240}
                    width="100%"
                    id="map"
                  />
                </Box>
              </Collapse>
            </Box>
          </Grid>
        </>
      )}
    </>
  );
};

export default CollipsableAddress;
